import { getRandomId } from "../id";
import { sortItem } from "../utils";
/**
 * Generic path tool
 * Customize it via the public options field
 */
export class PathTool {
    constructor(sketch, options = {}) {
        this.sketch = sketch;
        this.options = options;
        this.onDrawn = null;
        this.sketch.scope.activate();
        this.tool = new this.sketch.scope.Tool();
        this.tool.minDistance = 3;
        this.options = Object.assign({ shadowBlur: 1, strokeWidth: 10, strokeColor: "#d4ff3266" }, this.options);
        this.tool.onMouseDown = (ev) => this.onMouseDown(ev);
        this.tool.onMouseDrag = (ev) => this.onMouseDrag(ev);
        this.tool.onMouseUp = (ev) => this.onMouseUp(ev);
        this.tool.onKeyUp = (ev) => this.onKeyUp(ev);
    }
    enable() {
        this.tool.activate();
    }
    disable() {
        this.sketch.noTool.activate();
    }
    draw(data) {
        this.sketch.scope.activate();
        const path = new this.sketch.scope.Path();
        path.importJSON(data);
        sortItem(path);
    }
    onMouseDown(ev) {
        this.sketch.scope.activate();
        this.path = new this.sketch.scope.Path();
        const color = new this.sketch.scope.Color(this.options.strokeColor);
        this.path.set(Object.assign(Object.assign({}, this.options), { strokeCap: "round", strokeJoin: "round", strokeColor: color, shadowColor: color }));
        this.path.add(ev.point);
    }
    onMouseDrag(ev) {
        if (!this.path) {
            return;
        }
        this.sketch.scope.activate();
        this.path.add(ev.point);
    }
    onMouseUp(ev) {
        if (!this.path) {
            return;
        }
        this.sketch.scope.activate();
        this.path.simplify();
        if (this.onDrawn) {
            this.path.data = {
                tool: "path",
                id: getRandomId(),
                userId: this.sketch.userId,
                userEndpointId: this.sketch.userEndpointId,
            };
            this.onDrawn(this.path.exportJSON({ asString: false }));
        }
        this.path = null;
    }
    onKeyUp(ev) {
        this.sketch.scope.activate();
        if (ev.key === "escape" && this.path) {
            this.path.remove();
            this.path = null;
        }
    }
}
